<template>
    <div
        class="Spinner"
        :class="[
            { 'is-small': size === 'small' },
            { 'is-medium': size === 'medium' },
            { 'is-large': size === 'large' },
        ]"
    >
        <i class="ri-loader-4-line"></i>
    </div>
</template>
<script>
export default {
    props: {
        size: {
            default: 'small',
            type: String,
        },
    },
};
</script>
<style lang="scss" scoped>
.Spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    &.is-small {
        i {
            font-size: 1rem;
        }
    }
    &.is-medium {
        i {
            font-size: 2rem;
        }
    }
    &.is-large {
        i {
            font-size: 4rem;
        }
    }
    i {
        animation: spinner 1.2s cubic-bezier(0.14, 0.67, 1, 0.21) infinite;
    }
    @keyframes spinner {
        to {
            transform: rotate(360deg);
        }
    }
}
</style>
